import { clsx } from 'clsx';

import { ChevronDownIcon } from '../icon/icons/ChevronDownIcon';
import type { AccordionIndicatorProps } from './accordion.types';
import { useItemExpanded } from './accordionItemContext';

import styles from './accordion.module.css';

export const AccordionIndicator = ({
  className,
  'data-testid': testId,
  iconSize,
  id,
}: AccordionIndicatorProps) => {
  const isExpanded = useItemExpanded();

  return (
    <div>
      <ChevronDownIcon
        className={clsx(className, styles['accordionIndicator'], {
          [styles['accordionIndicator__expanded']]: isExpanded,
        })}
        data-testid={testId}
        id={id}
        size={iconSize}
      />
    </div>
  );
};
